<template>
<div class="bottom-pane">
  <el-input
    type="textarea"
    placeholder="请输入内容"
    :value="textarea"
    style="height: 100px"
    show-word-limit
  >
  </el-input>
</div>
</template>

<script>
export default {
  name: "SqlCmd",
  data(){
    return {
      textarea:"",
      from_obj:{},
      sql_obj:{
        master_table:"",
        join_table:[],
        table_filed:[],
      }
    }
  },
  mounted() {
  },
  methods:{
    initData(from_obj){
      var that=this;
      that.from_obj={}
      that.from_obj=JSON.parse(JSON.stringify(from_obj));
      this.bindSql()
    },
    bindSql(){
      var that=this;
      that.sql_obj={
        master_table:"",
        join_table:[],
        table_filed:[],
      }
      let st=new Set()
      that.from_obj.cells.forEach((item,index)=>{
        if(item.shape==='er-rect'){
          if((item.data||{}).checked){
            that.sql_obj.master_table=item.id;
            item.ports.items.filter(ret=>ret.checked).map(ret=>{
              return item.id+"."+ret.attrs.portNameLabel.text
            }).map(ret=>{
              that.sql_obj.table_filed.push(ret);
            })
          }
        }
      })
      that.from_obj.cells.forEach((item,index)=>{
        if(item.shape==='edge'){
          st.add(item.source.cell)
          st.add(item.target.cell)
          that.sql_obj.join_table.push({
            source_table:item.source.cell,
            target_table:item.target.cell,
            type:(item.data||{}).join_ext?item.data.join_ext:"inner join",
            on:item.source.port+"="+item.target.port
          });
        }
      })
      that.from_obj.cells.forEach((item,index)=>{
        if(item.shape==='er-rect'){
          if(!(item.data||{}).checked&&Array.from(st).includes(item.id)){
            item.ports.items.filter(ret=>ret.checked).map(ret=>{
              return item.id+"."+ret.attrs.portNameLabel.text
            }).map(ret=>{
              that.sql_obj.table_filed.push(ret);
            })
          }
        }
      })

      this.bindSql2()
    },
    bindSql2(){
      let master_table=this.sql_obj.master_table
      let join_table=this.sql_obj.join_table
      let table_filed=this.sql_obj.table_filed.length?this.sql_obj.table_filed.join(','):"*";
      let join_table_str=""
      join_table.map(ret=>{
        join_table_str+=ret.type +" "+ (master_table===ret.source_table?ret.target_table:ret.source_table)+" on "+ret.on+" "
      })
      master_table&&(this.textarea=`select ${table_filed} from ${master_table} ${join_table_str}`);
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-pane{
  position: absolute;
  right: 5px;
  bottom: 50px;
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Database/components/SqlCmd.vue